import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AppContext } from 'store/AppContext';

function PrivateRoute({ component: Component, role, ...rest }) {
    const context = useContext(AppContext);
    const isAuthenticated = context.isLoggedIn.get;
    const hasRoles = isAuthenticated && context.user.get && context.user.get.details.role;
    const roles = hasRoles ? context.user.get.details.role : [];

    const hasAccess = role ? roles.findIndex(r => r === role) !== -1
        : roles.findIndex(r => r === "utankjorfundarkerfi.notandi") !== -1;

    const pathname = isAuthenticated ? '/adgangur-bannadur' : '/innskraning';

  return (
    <Route {...rest}
      render={props => hasAccess ? <Component {...props} />
        : <Redirect to={{ pathname, state: { from: props.location } }} />}
    />
  );
}

export default PrivateRoute;